<template>
  <div>
    <div id="extension-dataview" class="page-table scrollable">
      <div class="flex justify-space-between align-center mt-20 mb-10">
        <h2 class="mt-0 mb-0">
          <v-svg class="voxo-blue" sprite="list-numbers" />
          Extension Table
        </h2>
        <el-button class="mb-0" @click="doExport"> Export </el-button>
      </div>
      <div class="extension-table card-base card-shadow--medium">
        <vxe-grid round border="inner" ref="xGrid" height="100%" auto-resize empty-text="No Data" show-overflow="tooltip"
          highlight-hover-row :data="tableData" :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="loading || tableLoading" :columns="[...tableColumns, ...defaultColumns]" />
      </div>
    </div>
  </div>
</template>
  
<script>
import moment from "moment-timezone";
import { ExportToCsv } from "export-to-csv";

export default {
  name: "ExtensionRecords",
  props: {
    loading: { required: true },
    records: { required: true }
  },
  components: {},
  data() {
    return {
      exportCSV: false,
      visibleActionsId: "",
      tableData: [],
      defaultColumns: [],
      tableLoading: false,
      partnerColumns: [
        {
          field: "partnerExtensions",
          title: "Partner Extensions",
          sortable: true,
          minWidth: 150,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.partnerExtensions}</span>
              ]
            }
          }
        },
        {
          field: "partnerPagingExtensions",
          title: "Partner Paging Extensions",
          sortable: true,
          minWidth: 195,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.partnerPagingExtensions}</span>
              ]
            }
          }
        },
        {
          field: "partnerSipTrunks",
          title: "Partner SIP Trunks",
          sortable: true,
          minWidth: 150,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.partnerSipTrunks}</span>
              ]
            }
          }
        },
        {
          field: "partnerResidentialExtensions",
          title: "Partner Residential Extenions",
          sortable: true,
          minWidth: 215,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.partnerResidentialExtensions}</span>
              ]
            }
          }
        },
        {
          field: "partnerTotalExtensions",
          title: "Partner Total Extenions",
          sortable: true,
          minWidth: 180,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.partnerTotalExtensions}</span>
              ]
            }
          }
        },
      ],
      tableColumns: [
        {
          field: "day",
          title: "Date",
          sortable: true,
          minWidth: 125,
          showOverflow: true,
          sortType: 'date',
          slots: {
            default: ({ row }) => {
              return [
                <span>{moment(row.day).format("YYYY-MMM-DD")}</span>
              ]
            }
          }
        },
        {
          field: "extensions",
          title: "Extensions",
          sortable: true,
          minWidth: 100,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.extensions}</span>
              ]
            }
          }
        },
        {
          field: "pagingExtensions",
          title: "Paging Extensions",
          sortable: true,
          minWidth: 150,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.pagingExtensions}</span>
              ]
            }
          }
        },
        {
          field: "sipTrunks",
          title: "SIP Trunks",
          sortable: true,
          minWidth: 100,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.sipTrunks}</span>
              ]
            }
          }
        },
        {
          field: "isResidential",
          title: "Residential Extensions",
          sortable: true,
          minWidth: 175,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.isResidential}</span>
              ]
            }
          }
        },
        {
          field: "totalExtensions",
          title: "Total Extensions",
          sortable: true,
          minWidth: 135,
          showOverflow: true,
          sortType: 'number',
          slots: {
            default: ({ row }) => {
              return [
                <span>{row.totalExtensions}</span>
              ]
            }
          }
        },
      ],
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.user;
    },
    isResellerAccount() {
      return this.selectedTenant
        ? this.selectedTenant.isResellerAccount
        : false;
    },
  },

  watch: {
    records() {
      //this.findExtensions();
      this.tableData = [...this.records].reverse();
    },
    isResellerAccount() {
      if (this.isResellerAccount) {
        this.defaultColumns = this.partnerColumns;
      } else {
        this.defaultColumns = [];
      }
    }
  },

  methods: {
    doExport() {
      this.$confirm(`Export data for ${this.tableData.length} Extension Records?`, {
        type: "warning",
      })
        .then(() => {
          //export from browser
          let csvData = [];
          for (let i = 0; i < this.tableData.length; i++) {

            const keys = ['day'];
            const dataKeys = [
              'day',
              'extensions',
              'pagingExtensions',
              'sipTrunks',
              'isResidential',
              'totalExtensions'
            ];
            if (this.isResellerAccount) {
              dataKeys.push(['partnerExtensions']);
              dataKeys.push(['partnerPagingExtensions']);
              dataKeys.push(['partnerSipTrunks']);
              dataKeys.push(['partnerResidentialExtensions']);
              dataKeys.push(['partnerTotalExtensions']);
            }


            const csvObject = {};
            const extensionStats = this.tableData[i];

            for (let key of keys) {
              for (let key of dataKeys) {
                csvObject[key] = extensionStats[key] === null ? 0 : extensionStats[key];

              }
              csvObject[key] = this.tableData[i][key] === null ? 0 : this.tableData[i][key];
            }
            csvData.push(csvObject);

            const lineItems = extensionStats.lineItems;

            if (lineItems) {

              //first push on the new headers for line items
              csvData.push({
                day: 'Date',
                extensions: 'Extensions',
                pagingExtensions: 'Paging Extensions',
                sipTrunks: 'SIP Trunks',
                isResidential: 'Residential Extensions',
                totalExtensions: 'Total Extensions',
              });

              if (this.isResellerAccount) {
                csvData.push({
                  partnerExtensions: 'Partner Extesnsions',
                  partnerPagingExtensions: 'Partner Paging Extensions',
                  partnerSipTrunks: 'Partner SIP Trunks',
                  partnerResidentialExtensions: 'Partner Residential Extensions',
                  partnerTotalExtensions: 'Partner Total Extensions'
                })
              }
              for (let i = 0; i < lineItems.length; i++) {
                let csvObjectDist = {};
                for (let key of dataKeys) {
                  csvObjectDist[key] = lineItems[i] === null ? 0 : lineItems[i];
                }
                csvObjectDist = { ...csvObjectDist }
                csvData.push(csvObjectDist);
              }
            }

          }
          let headers = []
          if (this.isResellerAccount) {
            let partnerHeaders = [
              "Date",
              "Extensions",
              "Paging Extensions",
              "SIP Trunks",
              "Residential Extensions",
              "Total Extensions",
              "Partner Extensions",
              "Partner Paging Extensions",
              "Partner SIP Trunks",
              "Partner Residential Extensions",
              "Partner Total Extensions"
            ];
            headers.push([...partnerHeaders]);
          } else {
            let defaultHeaders = [
              "Date",
              "Extensions",
              "Paging Extensions",
              "SIP Trunks",
              "Residential Extensions",
              "Total Extensions"
            ]
            headers.push([...defaultHeaders]);
          }
          const options = {
            filename: "extension_summary",
            showLabels: true,
            headers: headers
          };



          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(csvData);
        })
        .catch(() => true);
    },
  },

  mounted() {
    this.tableData = [...this.records].reverse();
    if (this.isResellerAccount) {
      this.defaultColumns = this.partnerColumns;
    } else {
      this.defaultColumns = [];
    }
  },

  filters: {},

};
</script>
  
<style lang="scss" scoped>
.extension-table {
  height: 500px;
}
</style>
  